<template>
  <div class="join-us-page">
    <Banner :bannerUrl="bannerUrl" :title="$t('joinUsPage.bannerTitle')">
      <template  v-slot:content>
        <div class="job-search fs">
          <a-input :placeholder="$t('joinUsPage.bannerInput')" />
          <a-button class="banner_btn" type="primary" @click="toJobDetail">{{ $t('joinUsPage.bannerBtn') }}</a-button>
        </div>
      </template>
    </Banner>
    <div class="container">
      <div class="job-list">
        <a-collapse
          v-model:activeKey="activeKey"
          class="job-info"
          :bordered="false"
        >
          <div class="top fb">
            <span class="job-name">跨境物流销售</span>
            <span class="wages">底薪+提成</span>
          </div>
          <div class="city">宁波,苏州,大连,合肥,成都,深圳,嘉兴,郑州,杭州</div>
          <div class="bottom fb">
            <span class="require">招聘5人 ｜&nbsp;&nbsp;不限&nbsp;&nbsp;｜ 1-3年工作经验</span>
            <a-button class="banner_btn" type="primary" @click="toJobDetail">{{ $t('joinUsPage.applyBtn') }}</a-button>
          </div>
          <a-collapse-panel key="1" header="展开" :showArrow="false">
            <div class="job-content">
              <div class="job-detail">
                <div class="info-title">工作职责</div>
                <p>1.合理利用公司平台资源，开发拓展新客户； 2.定期拜访客户，与同行客户保持常态性的交流沟通，了解客户的实际需求； 3.通过与客户的沟通了解与掌握市场行情及相关信息，及时向产品（航线）部门进行反馈； 4.根据客户需求制定相应的物流方案并报价，推广公司优势产品和服务； 5.协调处理业务推进过程中出现的爆舱改配、补货、甩箱、加载、重箱出卡等各类突发情况； 6.协助结算人员对应收未收款进行催收，完成业务回款； 7.其他工作。</p>
              </div>
              <div class="job-detail">
                <div class="info-title">职位要求：</div>
                <p>1.优秀的沟通及销售技能，表达能力强，高度的责任心及抗压能力； 2.具备一定的市场分析及判断能力，良好的客户服务意识； 3.2年以上物流销售经验，有一定的行业资源； 4.热爱销售，具有自信心，心态乐观，不满足于现状,有责任心，能承受较大的工作压力。</p>
              </div>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import Banner from '@/components/banner'
  import { useRouter} from 'vue-router';
  const router = useRouter();
  const bannerUrl = require('@assets/images/banner/banner-talent-concept.png');

  const activeKey = ref(['1']);

  const toJobDetail = () => {
    router.push({
      name: 'JobDetail'
    })
  }
</script>

<style lang="less" scoped>
.join-us-page {
  /deep/ .com-banner {
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(107.44deg, #313445 25.09%, rgba(49, 52, 69, 0) 61.95%);
    }
  }
  .job-search {
    .ant-input {
      font-size: 12px;
      width: 461px;
      height: 38px;
      padding: 11px 13px;
      border-radius: 0;
      &::placeholder {
        color: #8E8E8E;
      }
    }
    .ant-btn {
      width: 122px;
      height: 38px;
      line-height: 38px;
      font-size: 14px;
      padding: 0;
      margin-left: 9px;
    }
  }
  .job-list {
    margin-top: 55px;
    margin-bottom: 227px;
    .job-info {
      background: #F8F9FB;
      padding: 33px 37px 0 37px;
      border: solid 1px #E0E0E0;
      .top {
        font-size: 20px;
        line-height: 20px;
        margin-bottom: 12px;
        .job-name {
          color: #151E2C;
        }
        .wages {
          color: #158AFF;
          font-weight: 500;
        }
      }
      .city {
        color: #959595;
        font-size: 16px;
        margin-bottom: 28px;
      }
      .bottom {
        padding-bottom: 24px;
        border-bottom: dashed 1px #DEDEDE;
        .require {
          color: #959595;
          font-size: 16px;
          line-height: 20px;
        }
        .ant-btn {
          min-width: 100px;
          height: 40px;
        }
      }
      /deep/ .ant-collapse-item {
        display: flex;
        flex-direction: column-reverse;
        .ant-collapse-header {
          text-align: center;
          margin: 0;
          padding: 14px 0;
          .ant-collapse-header-text {
            color: #A7A7A7;
            font-size: 14px;
            line-height: 20px;
            margin: 0;
            padding: 0;
          }
        }
        .ant-collapse-content-box {
          padding: 0;
        }
        .job-content {
          padding: 30px 0;
          border-bottom: dashed 1px #DEDEDE;
          .job-detail {
            margin-bottom: 41px;
            &:last-child {
              margin-bottom: 0;
            }
            .info-title {
              font-size: 14px;
              color: #000;
              line-height: 20px;
              margin-bottom: 13px;
            }
            p {
              font-size: 12px;
              color: #8F8F8F;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
</style>